// extracted by mini-css-extract-plugin
export default {"container":"LH-z","header":"MH-z","details":"NH-z","link":"OH-z"};